import { VocabularyBundle } from '@/types';
import { PageableInterface } from '@prometheus/types';
import { api, getSortDirection } from '@prometheus/utils';
export const getVocabularyBundlesList = (
  searchParams: any
): Promise<PageableInterface<VocabularyBundle>> => {
  const { pageNumber, pageSize, sortBy } = searchParams;
  const sort = getSortDirection(sortBy);

  return api.get(
    `/vocabulary-bundles/list?size=${pageSize || ''}` +
      `&page=${pageNumber || ''}` +
      `&sort=${sort}`
  );
};

export const getDownloadedVocabularyBundlesList = (
  searchParams: any
): Promise<PageableInterface<VocabularyBundle>> => {
  const { pageNumber, pageSize, sortBy } = searchParams;
  const sort = getSortDirection(sortBy);

  return api.get(
    `/downloaded-vocabulary-bundles/list?size=${pageSize || ''}` +
      `&page=${pageNumber || ''}` +
      `&sort=${sort}`
  );
};

export const requestDownloadBundle = (
  externalId: string,
  value: VocabularyBundle
): Promise<VocabularyBundle> => {
  return api.post(`/vocabulary-bundles/${externalId}`, value);
};

export const requestUpdateBundle = (
  externalId: string,
  value: VocabularyBundle
): Promise<VocabularyBundle> => {
  return api.post(`/vocabulary-bundles/new-version/${externalId}`, value);
};
export const getCurrentUserAthenaAuth = (): Promise<{
  url: string;
  token: string;
}> => {
  return api.get('users/athena/current');
};

export const updateCurrentUserAthenaAuth = (body: {
  url: string;
  token: string;
}): Promise<{
  url: string;
  token: string;
}> => {
  return api.put('/users/athena', body);
};
